import { Component, Input, OnInit } from '@angular/core';
import { PhoneService } from '@wephone-app-phone/services';
import { HttpEngine } from '@wephone-core/service/http_engine';

@Component({
  selector: 'active-call-info',
  templateUrl: './active-call-info.component.html',
  styleUrls: ['./active-call-info.component.scss']
})
export class ActiveCallInfoComponent implements OnInit {
  private readonly URL_MARK_ITEM_AS_FINISHED = '/callcenter/outcallcampaign_item/mark_as_finished';
  @Input() public callData: any;

  constructor(
    private readonly phoneService: PhoneService,
    private readonly httpEngine: HttpEngine

  ) { }

  ngOnInit(): void {
  }

  get isCampaign(): boolean {
    return this.callData && this.callData.data_type === 'campaign';
  }

  get isTask(): boolean {
    return this.callData && this.callData.data_type === 'task';
  }

  get campaignName(): string {
    return this.callData && this.callData.data_desc;
  }

  get callDetails(): any {
    return this.callData && this.callData.details;
  }

  get callDetailKeys(): string[] {
    return Object.keys(this.callDetails || {});
  }

  cancelCampaignItem(): void {
    if (this.isCampaign) {
      // console.log('Cancelling campaign item with id ', this.callData.details.id);
      this.httpEngine.apiPostV2(this.URL_MARK_ITEM_AS_FINISHED,
        {
          item_id: this.callData.details.id,
          campaign_id: this.callData.details.campaign_id
        }
      );
      this.phoneService.getActiveCall().hangup();
    }
  }
}
